<template lang="pug">
.general
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $tc('ActionTemplate._name', 1) }}
    v-row
      v-col(cols="4")
        v-text-field(
          v-model="instance.name",
          :label="$t('ActionTemplate.name')",
        )
      v-col(cols="6")
        v-text-field(
          v-model="instance.description",
          :label="$t('ActionTemplate.description')",
        )
      v-col(cols="2")
        v-select(
          :value="instance.actionId",
          :label="$t('ActionTemplate.templateType')",
          :items="actions",
          :loading="typesLoading",
          return-object,
          item-text="name",
          item-value="id",
          @input="changeAction",
        )
    v-row
      v-col
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('ActionTemplate.createdAt')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.modifiedAt",
          :label="$t('ActionTemplate.modifiedAt')",
          disabled,
        )
      v-col
        v-text-field(
          :value="(instance.user || {}).fullName",
          :label="$t('ActionTemplate.userFullName')",
          disabled,
        )
</template>

<script>
import EntityMixin from '@/mixins';
import axios from 'axios';
import {
  SEND_EMAIL, 
  SEND_EMAIL_WITH_REPORT, 
  SEND_GEOBUS_HTTP_REQUEST, 
  SEND_GENERIC_HTTP_REQUEST, 
  CHANGE_STATUS_TO_ENTITY, 
  CREATE_PDF, 
  EXTERNAL_FORM, 
  GENERATE_DATA, 
  GENERATE_CUSTOM_LOGS, 
  DATA_INTEGRATION, 
  CALL_LABELS_MICRO_SERVICE, 
  CREATE_TEXT_FILE,
  EXECUTE_SCRIPT,
  SCHEDULE_ACTION
} from '@/components/ActionTemplate/constants.js';

export default {
  mixins: [EntityMixin],
  props: {
    slotProps: null,
    loading: null,
    uid: null,
  },
  data: () => ({
    actions: [],
    typesLoading: true,
  }),
  methods: {
    changeAction(val) {
      const { id } = val;
      this.$store.commit('SET_INSTANCE_PATH', { path: 'actionId', value: id });
      this.$emit('input', val);
    },
  },
  async created() {
    try {
      let acs = (await axios.get(
        `actions?Where[]=a => a.Name == "${SEND_EMAIL}" || 
        a.Name == "${SEND_EMAIL_WITH_REPORT}" || 
        a.name.Contains("${SEND_GEOBUS_HTTP_REQUEST}") || 
        a.name.Contains("${SEND_GENERIC_HTTP_REQUEST}") || 
        a.name.Contains("${CHANGE_STATUS_TO_ENTITY}") || 
        a.name.Contains("${CREATE_PDF}") || 
        a.name.Contains("${EXTERNAL_FORM}") || 
        a.name.Contains("${GENERATE_DATA}") || 
        a.name.Contains("${GENERATE_CUSTOM_LOGS}") || 
        a.name.Contains("${DATA_INTEGRATION}") || 
        a.name.Contains("${CALL_LABELS_MICRO_SERVICE}") || 
        a.name.Contains("${CREATE_TEXT_FILE}") || 
        a.name.Contains("${EXECUTE_SCRIPT}") ||
        a.name.Contains("${SCHEDULE_ACTION}")` ,
        {
            params: {
                withoutGlobalBusinessScope: true,
                pageSize: -1
            }
        }
    )).data.data;

      this.actions = [...acs]
    } catch(error) {
      console.log(this.$cleanString(error));
    } finally {
      this.typesLoading = false;
    }
  },
}
</script>
